<main>
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'planningDashboard.title' | translateWF: 'Planning Dashboard' }}</h1>
      </div>
    </div>

    <div class="cs-page-list-grid">
      <p-panel [header]="'planningDashboard.title' | translateWF: 'Planning Dashboard'">
        <p-card data-variant="compact">
          <p>planning-dashboard works!</p>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
